import script from "./Topping.vue?vue&type=script&setup=true&lang=js"
export * from "./Topping.vue?vue&type=script&setup=true&lang=js"

import "./Topping.vue?vue&type=style&index=0&id=3644940b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3644940b"]])

export default __exports__